export enum AuctionStatusEnum {
  Active = 'active',
  Paused = 'paused',
  Canceled = 'canceled',
  Finished = 'finished'
}
